// extracted by mini-css-extract-plugin
export default {"wrapper":"price_wrapper__j5TxR","price":"price_price__2Jjy8"};